import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IWarehouseTransferHeader_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IWarehouseTransferHeader_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class WarehouseTransferHeader_ScreenBase extends React.PureComponent<
  IWarehouseTransferHeader_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  warehousetransferheader_803595_value_kuikaSelectBoxRef: React.RefObject<any>;
  warehousetransferheader_653547_value_kuikaSelectBoxRef: React.RefObject<any>;
  warehousetransferheader_937415_value_kuikaSelectBoxRef: React.RefObject<any>;
  warehousetransferheader_755865_value_kuikaSelectBoxRef: React.RefObject<any>;
  warehousetransferheader_497198_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "8c9b9847-3857-429a-9964-b8b8f660ea87",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 588591, PropertyName: "value", Value: "Depolar Arası Transfer" },
        { Id: 690454, PropertyName: "value", Value: "Ofis Adı" },
        { Id: 803595, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 635712, PropertyName: "value", Value: "Depo Adı" },
        { Id: 653547, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 402915, PropertyName: "value", Value: "Karşı Ofis Adı" },
        { Id: 937415, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 982084, PropertyName: "value", Value: "Karşı Depo Adı" },
        { Id: 755865, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 7671, PropertyName: "value", Value: "İşlem Tarihi" },
        {
          Id: 497198,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 288, PropertyName: "value", Value: "Açıklama" },
        { Id: 414152, PropertyName: "placeholder", Value: "Açıklama Giriniz" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.warehousetransferheader_803595_value_kuikaSelectBoxRef =
      React.createRef();
    this.warehousetransferheader_653547_value_kuikaSelectBoxRef =
      React.createRef();
    this.warehousetransferheader_937415_value_kuikaSelectBoxRef =
      React.createRef();
    this.warehousetransferheader_755865_value_kuikaSelectBoxRef =
      React.createRef();
    this.warehousetransferheader_497198_value_kuikaDatetimeRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "warehousetransferheader",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferheader",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferheader",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
